import { render, staticRenderFns } from "./WorkflowStateChangeMessage.vue?vue&type=template&id=fc86d14c"
import script from "./WorkflowStateChangeMessage.vue?vue&type=script&lang=js"
export * from "./WorkflowStateChangeMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports